import listActions from 'src/modules/casestudy/list/casestudyListActions';
import CasestudyService from 'src/modules/casestudy/casestudyService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'CASESTUDY_DESTROY';

const casestudyDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: casestudyDestroyActions.DESTROY_STARTED,
      });

      await CasestudyService.destroyAll([id]);

      dispatch({
        type: casestudyDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.casestudy.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/casestudy');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: casestudyDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: casestudyDestroyActions.DESTROY_ALL_STARTED,
      });

      await CasestudyService.destroyAll(ids);

      dispatch({
        type: casestudyDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.casestudy.destroyAll.success'),
      );

      getHistory().push('/casestudy');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: casestudyDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default casestudyDestroyActions;
